import { useContext, useMemo } from 'react'
import { AdminContext } from './AdminContext'
import type { S3Io } from '../upload/s3'

export function useAdmin() {
  const ctx = useContext(AdminContext)
  if (!ctx) throw new Error('useAdmin must be used within an AdminProvider')
  return ctx
}

export function useAdminIo(): S3Io | null {
  const { state } = useAdmin()
  return useMemo(
    () =>
      state.status === 'admin'
        ? { credentials: state.credentials, region: import.meta.env.VITE_AWS_REGION }
        : null,
    [state],
  )
}
